import ApiHelper from "../../../common/utils/apiHelper";
import { buildAirlineMilesAndMoreBookingFields } from "../../../common/utils/transport/airlineBookingPayload";
import { type TransportAirlineApiContext } from "../../../common/utils/transport/airlineTransportContext";
import {
  buildDestinationTransportPayload,
  postDestinationTransportEstimation
} from "../../../common/utils/transport/destinationTransportEstimation";
// helpers
import { isEmailInvalid } from "../../../common/utils/helpers/isEmailInvalid";
import { checkForEmptyField } from "../../../common/utils/helpers/checkForEmptyFields";
import { extractFullNameParts } from "../../../common/utils/helpers/extractFullNameParts";
import { resolveAirportTaxiApiPaths } from "./helpers/resolveAirportTaxiApiPaths";
// actions / selectors
import { globalActionCreators, selectApiBaseUrl } from "../../../common/store/modules/globalModule";
import { confirmationActionCreators } from "../../../common/store/modules/bookingConfirmationModule";

// Toggle mock for airport taxi initial load
const USE_MOCK_AIRPORT_TAXI_INITIAL = false;

const MOCK_AIRPORT_TAXI_INITIAL_RESPONSE = {
  provider_title: "Prepaid taxi transfer Zurich airport to hotel",
  provider_description:
    "Airport Taxi Zürich description lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, met consectetur adipisicing elit. Quisquam, quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem is quos lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos lorem i END END END",
  provider_logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
    name: "airport-taxi-logo"
  },
  name: "Prepaid taxi transfer Zurich airport to hotel",
  type: "airport-taxi",
  main: null,
  logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/82ecfc69-f0e9-4a14-a512-65a2d57c49eb/b27567e4b4af463.png",
    name: "Airport Taxi Zürich Kloten AG"
  },
  provider_cover: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/82ecfc69-f0e9-4a14-a512-65a2d57c49eb/b51947493f42c69-332x118.png",
    name: "FMS_TAXI4ME"
  },
  items: [
    {
      id: 1204,
      name: "Airport",
      type: "airport-taxi",
      offer_type: null,
      code: "HGPT4ME",
      provider_name: "Airport Taxi Zürich Kloten AG",
      provider_logo_id: 24827,
      provider_cover_id: 24814,
      provider_logo: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/82ecfc69-f0e9-4a14-a512-65a2d57c49eb/b27567e4b4af463.png",
        name: "Airport Taxi Zürich Kloten AG"
      },
      departure_address: {
        name: "Airport",
        formatted: "Vorfahrt Abflug 1, 8302 Kloten"
      },
      destination_address: {
        name: "GET LOCAL Test Hotel Zürich",
        formatted: "Gasometerstrasse 9, 8005 Zurich"
      },
      airport_pickup: true,
      booking_setting: {
        customer_name: "mandatory",
        customer_email: "mandatory",
        customer_phone: "mandatory",
        comment: "shown",
        birthdate: "hidden"
      },
      time_limit: 20,
      cancellation_policy: "Cancellation policy Airport Taxi Zürich 1"
    }
  ]
};

export const airportTaxiActionTypes = {
  LOAD_AIRPORT_TAXI_INITIAL: "LOAD_AIRPORT_TAXI_INITIAL",
  TOGGLE_AIRPORT_TAXI_INITIAL_ERROR: "TOGGLE_AIRPORT_TAXI_INITIAL_ERROR",
  SET_SELECTED_RIDE: "SET_SELECTED_RIDE",
  TOGGLE_AIRPORT_TAXI_ESTIMATION_ERROR: "TOGGLE_AIRPORT_TAXI_ESTIMATION_ERROR",
  SET_BOOKING_ERROR_MESSAGE: "SET_BOOKING_ERROR_MESSAGE",
  TOGGLE_ESTIMATION_STATE: "TOGGLE_ESTIMATION_STATE",
  RESET_AIRPORT_TAXI_STATE: "RESET_AIRPORT_TAXI_STATE",
  SET_DATA_FOR_BOOKING: "SET_DATA_FOR_BOOKING",
  SET_BOOKING_RESPONSE_DATA: "SET_BOOKING_RESPONSE_DATA",
  TOGGLE_BOOKING_ERROR: "TOGGLE_BOOKING_ERROR",
  TOGGLE_AIRPORT_TAXI_PAYMENT_MODAL: "TOGGLE_AIRPORT_TAXI_PAYMENT_MODAL",
  SET_AIRPORT_TAXI_ESTIMATION: "SET_AIRPORT_TAXI_ESTIMATION"
};

export const initialState = {
  airportTaxiInitial: null,
  airportTaxiInitialItem: null,
  airportTaxiEstimation: null,
  airportTaxiInitialError: false,
  selectedRide: null,
  airportTaxiEstimationError: false,
  estimationAvailable: false, // flag which tells us if EP is called & stored on redux // when flag is TRUE, and user changes date/time/route --> flag will be changed to FALSE again
  bookingResponseData: null,
  showPaymentModal: false,
  bookingError: false,
  dataForBooking: {
    commentForm: "",
    emailForm: "",
    nameForm: "",
    mobileNumberForm: ""
  },
  bookingErrorMessage: []
};

const airportTaxiModule = (state = initialState, action: any) => {
  switch (action.type) {
    case airportTaxiActionTypes.LOAD_AIRPORT_TAXI_INITIAL: {
      return {
        ...state,
        airportTaxiInitial: action.airportTaxiInitial,
        airportTaxiInitialItem: action.airportTaxiInitialItem
      };
    }
    case airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_INITIAL_ERROR: {
      return {
        ...state,
        airportTaxiInitialError: action.airportTaxiInitialError
      };
    }

    case airportTaxiActionTypes.SET_AIRPORT_TAXI_ESTIMATION: {
      return {
        ...state,
        airportTaxiEstimation: action.airportTaxiEstimation
      };
    }
    case airportTaxiActionTypes.SET_SELECTED_RIDE: {
      return {
        ...state,
        selectedRide: action.selectedRide
      };
    }
    case airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_ESTIMATION_ERROR: {
      return {
        ...state,
        airportTaxiEstimationError: action.airportTaxiEstimationError
      };
    }
    case airportTaxiActionTypes.SET_BOOKING_ERROR_MESSAGE: {
      return {
        ...state,
        bookingErrorMessage: action.bookingErrorMessage
      };
    }
    case airportTaxiActionTypes.TOGGLE_ESTIMATION_STATE: {
      return {
        ...state,
        estimationAvailable: action.estimationAvailable
      };
    }
    case airportTaxiActionTypes.SET_DATA_FOR_BOOKING: {
      return {
        ...state,
        dataForBooking: action.dataForBooking
      };
    }
    case airportTaxiActionTypes.SET_BOOKING_RESPONSE_DATA: {
      return {
        ...state,
        bookingResponseData: action.bookingResponseData
      };
    }
    case airportTaxiActionTypes.TOGGLE_BOOKING_ERROR: {
      return {
        ...state,
        bookingError: action.bookingError
      };
    }
    case airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_PAYMENT_MODAL: {
      return {
        ...state,
        showPaymentModal: action.showPaymentModal
      };
    }
    case airportTaxiActionTypes.RESET_AIRPORT_TAXI_STATE: {
      return {
        ...state,
        airportTaxiInitial: null,
        airportTaxiInitialItem: null,
        selectedRide: null,
        airportTaxiEstimationError: false,
        estimationAvailable: false,
        airportTaxiEstimation: null,
        bookingResponseData: null,
        bookingError: false,
        dataForBooking: {
          commentForm: "",
          emailForm: "",
          nameForm: "",
          mobileNumberForm: ""
        }
      };
    }
    default:
      return state;
  }
};

export default airportTaxiModule;

export const airportTaxiActionCreators = {
  getAirportTaxiInitialAction:
    (transportContext: TransportAirlineApiContext) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      const paths = resolveAirportTaxiApiPaths(transportContext);

      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
      // reset error state
      dispatch({
        type: airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_INITIAL_ERROR,
        airportTaxiInitialError: false
      });

      if (paths.kind === "invalid_airline") {
        dispatch({
          type: airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_INITIAL_ERROR,
          airportTaxiInitialError: true
        });
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        return;
      }

      try {
        let data: any;

        if (USE_MOCK_AIRPORT_TAXI_INITIAL) {
          await new Promise(resolve => setTimeout(resolve, 300));
          data = MOCK_AIRPORT_TAXI_INITIAL_RESPONSE;
        } else {
          const res = await ApiHelper.get(`${apiUrl}/${paths.mainPath}`);
          data = res?.data;
        }

        dispatch({
          type: airportTaxiActionTypes.LOAD_AIRPORT_TAXI_INITIAL,
          airportTaxiInitial: data,
          airportTaxiInitialItem: data?.items?.[0]
        });

        const airportPickupOffer = data?.items?.find((offer: any) => offer.airport_pickup === true);

        dispatch({
          type: airportTaxiActionTypes.SET_SELECTED_RIDE,
          selectedRide: airportPickupOffer
        });
      } catch (err: any) {
        dispatch({
          type: airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_INITIAL_ERROR,
          airportTaxiInitialError: true
        });
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  toggleAirportTaxiEstimationErrorAction: (status: boolean) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_ESTIMATION_ERROR,
      airportTaxiEstimationError: status
    });
  },
  toggleEstimationAvailableStateAction: (status: boolean) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.TOGGLE_ESTIMATION_STATE,
      estimationAvailable: status
    });
  },
  setAirportTaxiEstimationAction: (airportTaxiEstimation: any) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.SET_AIRPORT_TAXI_ESTIMATION,
      airportTaxiEstimation: airportTaxiEstimation
    });
  },
  getEstimationAction:
    (params: any, transportContext: TransportAirlineApiContext) => async (dispatch: any, getState: any) => {
      // estimation valid state
      dispatch(airportTaxiActionCreators.toggleEstimationAvailableStateAction(false));
      const apiUrl = selectApiBaseUrl(getState()) || "";
      const selectedRide = getState().airportTaxi.selectedRide;

      const apiParams = buildDestinationTransportPayload({
        time: params?.time,
        date: params?.date,
        departureAddress: params?.departureAddress,
        departureAddressId: params?.departureAddressId ? params?.departureAddressId : null,
        destinationAddress: params?.destinationAddress,
        destinationAddressId: params?.destinationAddressId ? params?.destinationAddressId : null,
        milesAndMore: params?.milesAndMore ?? "",
        offerCode: selectedRide?.code ?? selectedRide?.offer_code ?? params?.offer_code
      });
      // turn on the loader
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

      try {
        const data = await postDestinationTransportEstimation({
          apiUrl,
          transportContext,
          payload: apiParams,
          v2: { type: "airport-taxi" },
          airline: { path: iataCode => `v1/airports/${encodeURIComponent(iataCode)}/transports/airport-taxi` }
        });

        // reset error state
        dispatch(airportTaxiActionCreators.toggleAirportTaxiEstimationErrorAction(false));
        // estimation valid state
        dispatch(airportTaxiActionCreators.toggleEstimationAvailableStateAction(true));
        // store estimation result (unified response)
        dispatch(airportTaxiActionCreators.setAirportTaxiEstimationAction(data));
      } catch (err: any) {
        dispatch(airportTaxiActionCreators.toggleAirportTaxiEstimationErrorAction(true));
        dispatch(airportTaxiActionCreators.toggleEstimationAvailableStateAction(false));
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
      }
    },
  resetAirportTaxiStateAction: () => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.RESET_AIRPORT_TAXI_STATE
    });
  },
  updateFormForBookingAction:
    (dataForBooking: { commentForm: string; emailForm: string; nameForm: string; mobileNumberForm: string }) =>
    (dispatch: any) => {
      dispatch({
        type: airportTaxiActionTypes.SET_DATA_FOR_BOOKING,
        dataForBooking: dataForBooking
      });
    },
  toggleBookingErrorAction: (bookingError: boolean) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.TOGGLE_BOOKING_ERROR,
      bookingError
    });
  },
  setErrorMessageAction: (message: any) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.SET_BOOKING_ERROR_MESSAGE,
      bookingErrorMessage: message
    });
  },
  togglePaymentModalAction: (showPaymentModal: boolean) => (dispatch: any) => {
    dispatch({
      type: airportTaxiActionTypes.TOGGLE_AIRPORT_TAXI_PAYMENT_MODAL,
      showPaymentModal
    });
  },
  buyTicketAction:
    (params: any, navigate: any, transportContext: TransportAirlineApiContext) =>
    async (dispatch: any, getState: any) => {
      const dataForBooking = getState().airportTaxi.dataForBooking;
      const airportTaxiInitialItem = getState().airportTaxi.airportTaxiInitialItem;
      const paths = resolveAirportTaxiApiPaths(transportContext);

      dispatch(airportTaxiActionCreators?.toggleBookingErrorAction(false));

      let errorField = {
        emailForm: false,
        commentForm: false,
        nameForm: false,
        mobileNumberForm: false
      };

      let errorCheck = true;

      if (
        isEmailInvalid(dataForBooking.emailForm) ||
        (checkForEmptyField(dataForBooking.emailForm) &&
          airportTaxiInitialItem?.booking_setting?.customer_email === "mandatory")
      ) {
        errorField.emailForm = true;
        errorCheck = false;
      }

      if (
        (airportTaxiInitialItem?.booking_setting?.comment === "mandatory" &&
          checkForEmptyField(dataForBooking.commentForm)) ||
        (dataForBooking?.commentForm !== "" && dataForBooking?.commentForm?.length < 3)
      ) {
        errorField.commentForm = true;
        errorCheck = false;
      }

      if (
        airportTaxiInitialItem?.booking_setting?.customer_name === "mandatory" &&
        checkForEmptyField(dataForBooking.nameForm)
      ) {
        errorField.nameForm = true;
        errorCheck = false;
      }

      if (
        airportTaxiInitialItem?.booking_setting?.customer_phone === "mandatory" &&
        checkForEmptyField(dataForBooking.mobileNumberForm)
      ) {
        errorField.mobileNumberForm = true;
        errorCheck = false;
      }

      if (!errorCheck) {
        dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: true, errorField: errorField });
      } else {
        dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: false, errorField: errorField });
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

        const selectedRide = getState().airportTaxi.selectedRide;

        // reset booking error message
        dispatch(airportTaxiActionCreators.setErrorMessageAction([]));

        // remove bookingResponseDataStorage from the storage, before setting it again
        localStorage.removeItem("bookingResponseDataStorage");

        const apiUrl = selectApiBaseUrl(getState());
        const language = localStorage.getItem("i18nextLng");

        const apiParams = {
          summary: {
            start_date: params?.start_date,
            adult: 1,
            timeslot: params?.timeslot,
            offer_code: selectedRide?.code
          },
          personal_information: {
            first_name: extractFullNameParts(dataForBooking.nameForm)?.firstName,
            last_name: extractFullNameParts(dataForBooking.nameForm)?.lastName,
            email: dataForBooking.emailForm,
            phone: dataForBooking.mobileNumberForm,
            comment: dataForBooking.commentForm ? dataForBooking.commentForm : null
          },
          ...buildAirlineMilesAndMoreBookingFields(transportContext),
          hotel_stay_code: getState().tenant.tenantInfo?.code,
          extraBookingData: {
            sendBookingConfirmationCopy: true,
            productId: selectedRide?.product_id,
            fareId: selectedRide?.price?.fare_id,
            category: selectedRide?.category,
            departureAddress: params?.departureAddress,
            departureAddressId: params?.departureAddressId ? params?.departureAddressId : null,
            destinationAddress: params?.destinationAddress,
            destinationAddressId: params?.destinationAddressId ? params?.destinationAddressId : null,
            attributes: []
          }
        };

        try {
          if (paths.kind === "invalid_airline") {
            dispatch(airportTaxiActionCreators?.toggleBookingErrorAction(true));
            return;
          }

          const response = await ApiHelper.post(`${apiUrl}/${paths.bookingsPath}`, {}, apiParams);

          localStorage.setItem("bookingResponseDataStorage", JSON.stringify(response.data));

          // We can get API status 200, with booking_status=error --> in that case we should show error page instead of Payment Modal / Confirmation Page
          if (response.data?.booking_status === "error") {
            dispatch(airportTaxiActionCreators?.toggleBookingErrorAction(true));
            return;
          } else {
            dispatch(airportTaxiActionCreators?.toggleBookingErrorAction(false));

            dispatch({
              type: airportTaxiActionTypes.SET_BOOKING_RESPONSE_DATA,
              bookingResponseData: response.data
            });

            // If price is 0 we will get payment_status=paid from API --> and we should redirect user directly to the /confirmation page (without payment modal)
            if (response.data?.payment_status === "paid") {
              // call booking status action, in order to set new value to the bookingStatus state
              await dispatch(confirmationActionCreators?.getBookingStatusAction());
              // redirect to confirmation
              await navigate(`/${language}/transport/airport-taxi/confirmation`, { replace: true });
            } else {
              // open payment modal (if status is not booked)
              dispatch(airportTaxiActionCreators?.togglePaymentModalAction(true));
            }
          }
        } catch (err: any) {
          if (err?.response?.data?.fields) {
            dispatch(airportTaxiActionCreators.setErrorMessageAction(err?.response?.data?.fields));
          }

          dispatch(airportTaxiActionCreators?.toggleBookingErrorAction(true));
        } finally {
          dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        }
      }
    }
};
